module.exports = __webpack_public_path__ + "static/media/fermer-recherche.689e84bc.png";